const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_dominican-flavor/artifacts/ghxglper_J%26W-DELI-LOGO-png.png";

/**
 * Brand logo for J & W Deli.
 *
 * Variants:
 *  - "default"  -> circular logo image (works on any background)
 *  - "compact"  -> small square mark for tight spaces (header/sidebar)
 *  - "stacked"  -> logo + wordmark side by side
 */
export default function Logo({
    variant = "default",
    size = 40,
    className = "",
    showWordmark = false,
    wordmarkClassName = "",
}) {
    const dim = { width: size, height: size };

    if (variant === "compact") {
        return (
            <div className={`inline-flex items-center gap-2 ${className}`}>
                <img
                    src={LOGO_URL}
                    alt="J & W Deli"
                    style={dim}
                    className="rounded-lg object-contain bg-white shadow-sm"
                    loading="eager"
                />
                {showWordmark && (
                    <span className={`font-display font-black tracking-tight ${wordmarkClassName}`}>
                        J & W Deli
                    </span>
                )}
            </div>
        );
    }

    return (
        <img
            src={LOGO_URL}
            alt="J & W Deli — La esquina del Sabor"
            style={dim}
            className={`object-contain ${className}`}
            loading="eager"
        />
    );
}

export { LOGO_URL };
